export const DOCUMENTS_ROOT = '/documents'

/** Encode one slash-separated Documents-library path for a URL pathname. */
export function encodeDocumentPath(path: string): string {
  return path
    .split('/')
    .filter((segment) => segment.length > 0)
    .map((segment) => encodeURIComponent(segment))
    .join('/')
}

/** Inverse of encodeDocumentPath. Returns null when a segment is not valid URI encoding. */
export function decodeDocumentPath(path: string): string | null {
  try {
    const segments = path
      .split('/')
      .filter((segment) => segment.length > 0)
      .map((segment) => decodeURIComponent(segment))
    return segments.length > 0 ? segments.join('/') : null
  } catch {
    return null
  }
}

function appendPage(href: string, pageNumber?: number): string {
  if (!Number.isInteger(pageNumber) || (pageNumber ?? 0) <= 0) return href
  return `${href}?page=${pageNumber}`
}

/** Stable Documents-library route for a cited path and optional PDF page. */
export function docsHubDocumentHref(path: string, pageNumber?: number): string {
  const encoded = encodeDocumentPath(path)
  const href = encoded.length > 0 ? `${DOCUMENTS_ROOT}/${encoded}` : DOCUMENTS_ROOT
  return appendPage(href, pageNumber)
}

/**
 * Authenticated in-app preview route for one ingest-job corpus source.
 * The page reuses SourceDocViewer, which performs the header-authenticated
 * source fetch instead of exposing object-storage URLs in agent output.
 */
export function ingestSourceDocumentHref(jobId: string, path: string, pageNumber?: number): string {
  const params = new URLSearchParams({ path })
  if (Number.isInteger(pageNumber) && (pageNumber ?? 0) > 0) {
    params.set('page', String(pageNumber))
  }
  return `/ingest/jobs/${encodeURIComponent(jobId)}/source-document?${params.toString()}`
}
